export default __webpack_public_path__ + "locales/lo-LA/Errors.json?hash=355a9cc46489d5edc4ba61ee8260947b";